import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '说明',
    textProp: 'algTitle',
    type: 'EVENT_DESC',
}
